import toast from 'react-hot-toast'
import { WARNING_ICON } from '../components/Toast'
import { AlertCopyId, getAlertCopy } from './alertCopy'

/**
 * Fire a toast from the standardized copy catalog instead of an inline
 * string. This is the migration target for existing
 * `toast.success('...')` / `toast.error('...')` call sites.
 *
 *   fireAlertToast('album.deleted')
 *   fireAlertToast('photo.deleted', { title: '"Rain walk, no. 4" deleted' })
 */
export function fireAlertToast(id: AlertCopyId, overrides?: { title?: string; duration?: number }) {
  const copy = getAlertCopy(id)
  const title = overrides?.title ?? copy.title
  const duration = overrides?.duration ?? copy.duration

  switch (copy.variant) {
    case 'success':
      return toast.success(title, { duration })
    case 'error':
      return toast.error(title, { duration })
    case 'warning':
      return toast(title, { duration, icon: WARNING_ICON })
    case 'info':
    default:
      return toast(title, { duration })
  }
}
